import { replaceLast } from '../../../utils/stringUtils';

export const getMatch = (str: string, substringBefore: string, substringAfter: string) => {
  const matchWithSubstringAfter = str.replace(substringBefore, '');
  return replaceLast(matchWithSubstringAfter, substringAfter);
};